<h3 class="text-overflow">
    <a ng-if="showOpen" ng-click="onMainClick(item, $event)">
        <span ng-bind-html="item.Title|cHighlight:highlight"></span>
    </a>
    <span ng-if="!showOpen" ng-bind-html="item.Title|cHighlight:highlight"></span>
    <!--a class="details" ng-class="{isFavorite: item.IsFavorite}" ng-click="onFavoritesClick(item, $event)" ng-attr-title="{{ 'workflowList.favorite'|translate }}"></a-->
    <!--a class="details button" ng-click="onDetailsClick(item, $event)" ng-attr-title="{{ 'workflowList.details'|translate }}"><i class="fa fa-info"></i></a-->
</h3>
<p ng-bind-html="(item.Abstract ? item.Abstract + '...' : item.Description)|cHighlight:highlight" class="description">
</p>
<c-property-list properties="item.itemProperties" highlight="highlight" style="display: inline-block"></c-property-list>
